import {
  EditChargingCardFormData,
  EditChargingCardPayload,
  EditChargingCardVehiclePayload,
  EMobilityChargingCardsDataModel,
} from '../models/e-mobility-charging-cards-models'
import { AxiosResponse } from 'axios'
import { FetchProps } from '@e3dc-react/shell/Hooks/AuthFetch/AuthFetch'
import { isEqual } from 'lodash'

export const editChargingCardApi = (
  data: EMobilityChargingCardsDataModel,
  formData: EditChargingCardFormData,
  serialNo: string,
  authFetch: <T>(props: FetchProps) => Promise<AxiosResponse<T>>,
  initialValues: EditChargingCardFormData
): Promise<unknown> => {
  const cardPayload: EditChargingCardPayload = {
    name: formData.chargingCardName || '',
    description: formData.chargingCardDescription || '',
    status: formData.status,
  }

  const vehiclePayload: EditChargingCardVehiclePayload = {
    name: formData.vehicleName || '',
    description: formData.vehicleDescription || '',
    color: data.color,
    horsepower: data.horsePower || '',
    licensePlate: formData.licensePlate || '',
    avgConsumption: +formData.avgConsumption,
    batteryCapacity: +formData.batteryCapacity,
  }

  const editCard = authFetch({
    endpoint: process.env.REACT_APP_EMOBILITY_ENDPOINT,
    path: `e-mobility/${serialNo}/cards/${data.rfid}`,
    method: 'PUT',
    payload: cardPayload,
  })

  const editVehicle = authFetch({
    endpoint: process.env.REACT_APP_EMOBILITY_ENDPOINT,
    path: `e-mobility/${serialNo}/cars/${data.vehicleId}`,
    method: 'PUT',
    payload: vehiclePayload,
  })

  const addVehicle = authFetch({
    endpoint: process.env.REACT_APP_EMOBILITY_ENDPOINT,
    path: `e-mobility/${serialNo}/cars`,
    method: 'POST',
    payload: { ...vehiclePayload, rfid: data.rfid },
  })

  const shouldAddVehicle = !data.vehicleId && !isEqual(formData, initialValues)

  return Promise.all([editCard, shouldAddVehicle ? addVehicle : editVehicle])
}
